import React from 'react'

export default function Servicios() {
  return (
    <section id='servicios' className="services-section py-16 md:py-24 bg-base-200">
      <div className="container mx-auto  md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h1 style={{textAlign:'center'}} className="text-3xl md:text-4xl lg:text-5xl font-bold piel2">
          Soluciones Tecnológicas para el Cambio Climático
          </h1>
        </div>
        
        <div className="serv grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-7xl mx-auto fade-in-on-scroll">
          
          <div style={{justifySelf:'end'}} className="card2   w-full">
            <div className="card-body">
              <h2 className="card-title piel">Nuestra Plataforma de IA</h2>
              <p className='piel2'>Presentamos una solución innovadora que utiliza inteligencia artificial avanzada para ayudarte a combatir el cambio climático. Nuestra plataforma te permite:</p>
            <ul >
              <li className='li2'>Cuantificar con precisión tu huella de carbono.</li>
              <li className='li2'>Identificar oportunidades de reducción de emisiones.</li>
              <li className='li2'>Desarrollar estrategias de compensación efectivas</li>
            </ul>
            
            </div>
          </div>

          <div className="grid grid-cols-1  fade-in-on-scroll">
          <h2 className="card-title piel">Caracteristicas</h2>
          <div style={{marginTop:'1rem'}} className='grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto fade-in-on-scroll'>
          <div className="card2  mx-auto w-full">
            <div className="">
            <svg style={{marginBottom:'1rem'}} class="colorable-icon" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" data-icon="calculator" data-prefix="fal" aria-hidden="true"><path d="M352 160V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160H352zm0-32H32V64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64zm32 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v64 16 16V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160 144 128zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z" fill="currentColor"></path></svg>
              
              <h2 className="card-title piel">Cálculo Preciso</h2>
              <p className='piel2'>Medición exacta de emisiones de GEI</p>
            </div>
          </div>

          <div className="card2  mx-auto w-full">
            <div className="">
            <svg style={{marginBottom:'1rem'}} class="colorable-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" data-icon="brain" data-prefix="fal" aria-hidden="true"><path d="M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c23.9 13.8 40 39.7 40 69.3c0 5.1-.5 10.1-1.4 15c15.8 17.1 25.4 40 25.4 65c0 29.8-13.6 56.4-34.8 74c1.8 7.1 2.8 14.4 2.8 22c0 48.6-39.4 88-88 88c-.9 0-1.8 0-2.7 0c-13.8 23.9-39.7 40-69.3 40c-26.2 0-49.4-12.6-64-32zm16-48c0 26.5 21.5 48 48 48c20.4 0 37.9-12.8 44.8-30.8c2.7-7.1 10.1-11.3 17.6-10c3.1 .5 6.3 .8 9.5 .8c30.9 0 56-25.1 56-56c0-7.8-1.6-15.2-4.4-21.8c-3.1-7.2-.4-15.7 6.3-19.8C468 331 480 310.9 480 288c0-19.1-8.4-36.3-21.7-48.1c-4.8-4.2-6.6-10.9-4.6-17c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48V432z" fill="currentColor"></path></svg>
              <h2 className="card-title piel">IA Avanzada</h2>
              <p className='piel2'>Análisis y recomendaciones personalizadas</p>
            </div>
          </div>

          <div className="card2  mx-auto w-full">
            <div className="">
            <svg style={{marginBottom:'1rem'}} class="colorable-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" data-icon="leaf" data-prefix="fal" aria-hidden="true"><path d="M132 238.3c23.6-9.3 49.2-14.3 76-14.3h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-28.8 0-56 6.9-80 19.2C129.7 353.2 193.5 416 272 416h0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128l-104 0c-67.9 0-124.9 47-140 110.3zM96.7 256.3C104.7 166.4 180.1 96 272 96l104 0c35.2 0 66.6-16.2 87.2-41.7l.6-.8c2.3-2.9 4.4-5.8 6.4-8.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6s2.3 7.1 3.4 10.8l.4 1.5c8.8 30.3 13.5 62.8 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-89.4 0-163.2-66.7-174.5-153C57.5 327.3 32 376.7 32 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-73.9 38.6-138.9 96.7-175.7z" fill="currentColor"></path></svg>
              <h2 className="card-title piel">Compensación</h2>
              <p className='piel2'>Estrategias efectivas de mitigación</p>
            </div>
          </div>
          </div>
          
          </div>

          
          

          
        </div>
        <div style={{display:'grid'}}>
        <h1 style={{textAlign:'center'}} className="text-2xl md:text-4xl lg:text-5xl font-bold piel2">
        ¿Listo para comenzar a reducir tu huella de carbono?
          </h1>
          <a style={{fontSize:'1.5rem', color:'white', justifySelf:'center',marginTop:'1rem'}}
                target='_blank'
                href="https://chat.gei.cl/"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn btn-primary w-full md:w-auto cursor-pointer"
              >
                Prueba nuestro Chatbot Beta
              </a>
              </div>
      </div>
    </section>
  )
}
